"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var store_exports = {};
__export(store_exports, {
  store: () => store
});
module.exports = __toCommonJS(store_exports);
var import_vuex = __toESM(require("vuex"), 1);
var config = __toESM(require("./config"), 1);
var device = __toESM(require("./device"), 1);
var menus = __toESM(require("./menus"), 1);
function generateModulesByOptions(options) {
  const modulesByOptionsMapping = {
    enableConfig: {
      config: {
        namespaced: true,
        ...config
      }
    },
    enableDevice: {
      device: {
        namespaced: true,
        ...device
      }
    },
    enableMenus: {
      menus: {
        namespaced: true,
        ...menus
      }
    }
  };
  const modules = Object.keys(options).reduce((modulesObj, currentOption) => {
    return {
      ...modulesObj,
      ...options[currentOption] && modulesByOptionsMapping[currentOption]
    };
  }, {});
  return modules;
}
function serverInitByOptions(options, { $api, $ua, i18n }, { dispatch }) {
  const initFunctionsByOptionsMapping = {
    enableConfig: async () => await dispatch("config/load", { $api, locale: i18n.locale }),
    enableDevice: async () => await dispatch("menus/load", { $api, locale: i18n.locale }),
    enableMenus: async () => await dispatch("device/setUserDevice", { $ua })
  };
  return Promise.all(Object.keys(options).map((optionKey) => {
    if (!options[optionKey])
      return void 0;
    return initFunctionsByOptionsMapping[optionKey]();
  }));
}
function store(options) {
  const defaultOptions = {
    enableConfig: true,
    enableMenus: true,
    enableDevice: true
  };
  const finalOptions = { ...defaultOptions, ...options };
  return new import_vuex.default.Store({
    strict: false,
    state: () => ({}),
    actions: {
      async nuxtServerInit(nuxtActions, nuxtContext) {
        await serverInitByOptions(finalOptions, nuxtContext, nuxtActions);
      }
    },
    modules: generateModulesByOptions(finalOptions)
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  store
});
